import { ApiService } from '../../utils/api-service';
import { ApiServiceConfig, AuthenticationMethod, HttpMethod, RequestOptions } from '../../utils/http-types';
import parseJwt from '../../utils/jwt-parser';

import TokenRetriever from '../../components/Authentication/TokenRetriever';
import currentStage from "../../stages.const";

type ApiConfig = {
    endpoint: string,
    api_key: string,
    cognito_id: string,
}

export class FederateApiService {

    private apiService: ApiService;
    private readonly AWS_PARTITION = "aws";
    private readonly ID_TOKEN_PROP = "idToken";
    private readonly ID_TOKEN_EXP_PROP = "idTokenExpireTimestamp";

    constructor(options: ApiServiceConfig) {
        this.apiService = new ApiService({
            baseUrl: options.baseUrl
        });
    }

    public async request(
        description: string,
        method: HttpMethod,
        url: string,
        data: {[key: string]: any} = {},
        options: RequestOptions = {}) {

        if (!this.apiService) {
            throw new Error("Api service is not yet initialized. Missing api config?");
        }

        // console.log(`ApiService.request.currentStage --> ${currentStage}`)
        const tr = new TokenRetriever(currentStage)
        const federateToken = await tr.getTokenOrRedirect();

        return this.apiService.request(description, method, url, data, Object.assign({
            httpConfig: {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': federateToken,
                }
            }
        }, options));
    }

    // convenience methods
    public get(url: string, data?: {[key: string]: any}, options?: RequestOptions) {
        return this.request("", HttpMethod.GET, url, data, options);
    }

    public post(url: string, data: {[key: string]: any}, options?: RequestOptions) {
        return this.request("", HttpMethod.POST, url, data, options);
    }

    public put(url: string, data: {[key: string]: any}, options?: RequestOptions) {
        return this.request("", HttpMethod.PUT, url, data, options);
    }

    public delete(url: string, data?: {[key: string]: any}, options?: RequestOptions) {
        return this.request("", HttpMethod.DELETE, url, data, options);
    }
}

// Export as default for backward compatibility
export { FederateApiService as ApiService };
